import { useEffect, useState } from "react";
import { noticeError } from "../../../App.newrelic";
import { APP_API_URL } from "../../../config/Environment";
import { useToken } from "./token";

const defaultOpts = {};
export const useDelete = (input, opts = defaultOpts, refreshFlag = true) => {
  const { token } = useToken();
  const [deleteError, setError] = useState(null);
  const [deleteLoading, setLoading] = useState(false);
  const [deleteData, setData] = useState(null);
  const { readBody = (body) => body.json() } = opts;
  const abortController = new AbortController();
  const signal = abortController.signal;

  useEffect(() => {
    (async () => {
      setError(null);
      if (input && refreshFlag && token) {
        let url = APP_API_URL + input;
        setLoading(true);
        try {
          const response = await fetch(url, {
            method: "DELETE",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: token.tokenType + " " + token.token,
            },
            signal: signal,
            mode: "cors",
          });
          if (response.ok) {
            const body = await readBody(response);
            setData(body);
            setError(null);
            setLoading(false);
          } else {
            const body = await readBody(response);
            if (body && body.error) {
              setError(body.error);
            } else {
              setError(body.message);
            }
            setLoading(false);
          }
        } catch (e) {
          console.log("E", e);
          noticeError(e);
          // setData([]);
          setError(e);
          setLoading(false);
        }
      }
    })();
    // eslint-disable-next-line
  }, [input, opts, refreshFlag]);

  useEffect(() => {
    return () => {
      abortController.abort();
    };
    // eslint-disable-next-line
  }, []);

  return { deleteError, deleteLoading, deleteData };
};
